import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { VehiclesGroupsActions } from 'state/modules/vehiclesGroups';
import withWidth from '@material-ui/core/withWidth';
import { PricingRulesWidget } from 'components/PricingRules';
import { withRouter } from 'react-router-dom';

const VehicleGroupPricingRules = ({ id, fleet = false }) => {
  const dispatch = useDispatch();
  const [params, setParams] = useState({
    page: 1,
    limit: 3,
  });
  const { current } = useSelector((state) => state.vehiclesGroups);

  useEffect(() => {
    if (current?.id) {
      dispatch(VehiclesGroupsActions.fetchVehiclesGroupRulesets(current?.id));
    }
  }, [dispatch, current]);

  const onDeletePricingRule = (rulesetId) => {
    dispatch(
      VehiclesGroupsActions.deleteRulesetFromVehiclesGroups(current?.id, rulesetId, {
        data: { rule_set_type: 'PRICING' },
      })
    );
  };

  const handleChangePage = (event, newPage) => {
    const newParams = { ...params, page: newPage + 1 };
    setParams(newParams);
    dispatch(VehiclesGroupsActions.fetchVehiclesGroupRulesets(current?.id, newParams));
  };

  return (
    <>
      <PricingRulesWidget
        params={params}
        currentGroup={current}
        handleChangePage={handleChangePage}
        onDelete={onDeletePricingRule}
        fleet={fleet}
      />
    </>
  );
};

export default withWidth()(withRouter(VehicleGroupPricingRules));
